import { PageWrapper, Spin } from "@/components";
import { useViperProfile } from "@/hooks";
import { useGetCDNFilePathQuery } from "@/services";
import { Button, Card } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const DownloadFile = () => {
  const user = useViperProfile();
  const filepathParams = useParams();
  const intl = useIntl();

  const [initialDownload, setInitialDownload] = useState(true);
  const [errorMessage, setErrorMessage] = useState();

  const projectId = filepathParams.projectId;
  const fileId = filepathParams.fileId;

  const {
    data: cdnFilePath,
    isFetching,
    isError,
    error,
  } = useGetCDNFilePathQuery({
    projectId,
    fileId,
  });

  useEffect(() => {
    if (isError) {
      setErrorMessage(() => {
        switch (error.status) {
          case 403:
            return intl.formatMessage({
              id: "viewDocument.accessDenied",
            });
          case 404:
            return intl.formatMessage({
              id: "viewDocument.documentNotFound",
            });
          default:
            return intl.formatMessage({ id: "general.error" });
        }
      });
    }

    if (!initialDownload || !user || !cdnFilePath) return;

    setInitialDownload(false);
    window.location.assign(cdnFilePath);

    setInitialDownload(true);
  }, [
    filepathParams,
    cdnFilePath,
    initialDownload,
    intl,
    user,
    isError,
    error,
  ]);

  useEffect(() => {
    if (errorMessage) toast.error(errorMessage);
  }, [errorMessage]);

  const downloadFileAgain = () => {
    if (cdnFilePath) {
      window.location.assign(cdnFilePath);
    }
  };

  if (isFetching) return <Spin />;

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "viewDocument.pageTitle" })}
      noStyle
    >
      <Card>
        <Button
          onClick={downloadFileAgain}
          data-test-id="Download-Milestone-File-Download-Again-Button"
          disabled={isError}
        >
          {intl.formatMessage({ id: "viewDocument.downloadAgain" })}
        </Button>
      </Card>
    </PageWrapper>
  );
};
